"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasetsApi = exports.DatasetsApiFactory = exports.DatasetsApiFp = exports.DatasetsApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * DatasetsApi - axios parameter creator
 * @export
 */
const DatasetsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {DatasetGroupDTO} [datasetGroupDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetGroupsResourceCreateGroup: (datasetGroupDTO_1, ...args_1) => __awaiter(this, [datasetGroupDTO_1, ...args_1], void 0, function* (datasetGroupDTO, options = {}) {
            const localVarPath = `/dataset-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(datasetGroupDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetGroupsResourceDeleteGroup: (id_1, ...args_2) => __awaiter(this, [id_1, ...args_2], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('datasetGroupsResourceDeleteGroup', 'id', id);
            const localVarPath = `/dataset-groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetGroupsResourceGetAllRootGroups: (...args_3) => __awaiter(this, [...args_3], void 0, function* (options = {}) {
            const localVarPath = `/dataset-groups/all-root`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetGroupsResourceGetGroup: (id_2, ...args_4) => __awaiter(this, [id_2, ...args_4], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('datasetGroupsResourceGetGroup', 'id', id);
            const localVarPath = `/dataset-groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {DatasetGroupDTO} [datasetGroupDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetGroupsResourceUpdateGroup: (id_3, datasetGroupDTO_2, ...args_5) => __awaiter(this, [id_3, datasetGroupDTO_2, ...args_5], void 0, function* (id, datasetGroupDTO, options = {}) {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('datasetGroupsResourceUpdateGroup', 'id', id);
            const localVarPath = `/dataset-groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(datasetGroupDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create categorized(local and remote) dataset
         * @param {DatasetInfo} [datasetInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceCreateCategorizedDataset: (datasetInfo_1, ...args_6) => __awaiter(this, [datasetInfo_1, ...args_6], void 0, function* (datasetInfo, options = {}) {
            const localVarPath = `/datasets/create-categorized`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(datasetInfo, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [allowEmptyQuery]
         * @param {string} [identifiers]
         * @param {number} [page]
         * @param {string} [query]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetAllDatasetInfosPaginated: (allowEmptyQuery_1, identifiers_1, page_1, query_1, size_1, ...args_7) => __awaiter(this, [allowEmptyQuery_1, identifiers_1, page_1, query_1, size_1, ...args_7], void 0, function* (allowEmptyQuery, identifiers, page, query, size, options = {}) {
            const localVarPath = `/datasets/infos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (allowEmptyQuery !== undefined) {
                localVarQueryParameter['allowEmptyQuery'] = allowEmptyQuery;
            }
            if (identifiers !== undefined) {
                localVarQueryParameter['identifiers'] = identifiers;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all allowed datasets for request user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetAllowedDatasets: (...args_8) => __awaiter(this, [...args_8], void 0, function* (options = {}) {
            const localVarPath = `/datasets/allowed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetBaseDataset: (identifier_1, ...args_9) => __awaiter(this, [identifier_1, ...args_9], void 0, function* (identifier, options = {}) {
            // verify required parameter 'identifier' is not null or undefined
            (0, common_1.assertParamExists)('datasetResourceGetBaseDataset', 'identifier', identifier);
            const localVarPath = `/datasets/{identifier}`
                .replace(`{${"identifier"}}`, encodeURIComponent(String(identifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [categoryIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetCategories: (categoryIds_1, ...args_10) => __awaiter(this, [categoryIds_1, ...args_10], void 0, function* (categoryIds, options = {}) {
            const localVarPath = `/datasets/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (categoryIds !== undefined) {
                localVarQueryParameter['categoryIds'] = categoryIds;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [category]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetCompanyCategoryInfo: (category_1, ...args_11) => __awaiter(this, [category_1, ...args_11], void 0, function* (category, options = {}) {
            const localVarPath = `/datasets/categoryInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [categoryId]
         * @param {string} [tags]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetByTags: (categoryId_1, tags_1, ...args_12) => __awaiter(this, [categoryId_1, tags_1, ...args_12], void 0, function* (categoryId, tags, options = {}) {
            const localVarPath = `/datasets/byTags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }
            if (tags !== undefined) {
                localVarQueryParameter['tags'] = tags;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetCount: (...args_13) => __awaiter(this, [...args_13], void 0, function* (options = {}) {
            const localVarPath = `/datasets/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get actual dataset data in the provided data period
         * @param {string} dataObj DatasetDataRequestObject which contains DatasetIdentifier and data period start and end localized time moments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetData: (dataObj_1, ...args_14) => __awaiter(this, [dataObj_1, ...args_14], void 0, function* (dataObj, options = {}) {
            // verify required parameter 'dataObj' is not null or undefined
            (0, common_1.assertParamExists)('datasetResourceGetDatasetData', 'dataObj', dataObj);
            const localVarPath = `/datasets/data/interval/{dataObj}`
                .replace(`{${"dataObj"}}`, encodeURIComponent(String(dataObj)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get dataset aggregated data in the provided data period, using the rules defined in query parameters.
         * @param {object} aggregationPeriod ChronoUnit which dictates data aggregation period/frequency
         * @param {number} from Instant object which represents the start of the data period
         * @param {number} to Instant object which represents the end of the data period
         * @param {{ [key: string]: AggregationType; }} [requestBody]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetDataAggregated: (aggregationPeriod_1, from_1, to_1, requestBody_1, ...args_15) => __awaiter(this, [aggregationPeriod_1, from_1, to_1, requestBody_1, ...args_15], void 0, function* (aggregationPeriod, from, to, requestBody, options = {}) {
            // verify required parameter 'aggregationPeriod' is not null or undefined
            (0, common_1.assertParamExists)('datasetResourceGetDatasetDataAggregated', 'aggregationPeriod', aggregationPeriod);
            // verify required parameter 'from' is not null or undefined
            (0, common_1.assertParamExists)('datasetResourceGetDatasetDataAggregated', 'from', from);
            // verify required parameter 'to' is not null or undefined
            (0, common_1.assertParamExists)('datasetResourceGetDatasetDataAggregated', 'to', to);
            const localVarPath = `/datasets/data/intervalAggregated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (aggregationPeriod !== undefined) {
                for (const [key, value] of Object.entries(aggregationPeriod)) {
                    localVarQueryParameter[key] = value;
                }
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetInfo: (identifier_2, ...args_16) => __awaiter(this, [identifier_2, ...args_16], void 0, function* (identifier, options = {}) {
            // verify required parameter 'identifier' is not null or undefined
            (0, common_1.assertParamExists)('datasetResourceGetDatasetInfo', 'identifier', identifier);
            const localVarPath = `/datasets/{identifier}/info`
                .replace(`{${"identifier"}}`, encodeURIComponent(String(identifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all user allowed datasets in DatasetDTO format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetList: (...args_17) => __awaiter(this, [...args_17], void 0, function* (options = {}) {
            const localVarPath = `/datasets/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get dataset most recent value list using current server time. Values are ordered from newest to oldest.
         * @param {number} datasetId Categorized dataset database ID
         * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
         * @param {number} [count]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetMostRecentValues: (datasetId_1, adjustContinuous_1, count_1, ...args_18) => __awaiter(this, [datasetId_1, adjustContinuous_1, count_1, ...args_18], void 0, function* (datasetId, adjustContinuous, count, options = {}) {
            // verify required parameter 'datasetId' is not null or undefined
            (0, common_1.assertParamExists)('datasetResourceGetDatasetMostRecentValues', 'datasetId', datasetId);
            const localVarPath = `/datasets/data/recent/{datasetId}`
                .replace(`{${"datasetId"}}`, encodeURIComponent(String(datasetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (adjustContinuous !== undefined) {
                localVarQueryParameter['adjustContinuous'] = adjustContinuous;
            }
            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {DatasetRequestFilter} [datasetRequestFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasets: (datasetRequestFilter_1, ...args_19) => __awaiter(this, [datasetRequestFilter_1, ...args_19], void 0, function* (datasetRequestFilter, options = {}) {
            const localVarPath = `/datasets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(datasetRequestFilter, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [categoryId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetsByCategory: (categoryId_2, ...args_20) => __awaiter(this, [categoryId_2, ...args_20], void 0, function* (categoryId, options = {}) {
            const localVarPath = `/datasets/byCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [groupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetsByGroup: (groupId_1, ...args_21) => __awaiter(this, [groupId_1, ...args_21], void 0, function* (groupId, options = {}) {
            const localVarPath = `/datasets/byGroup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (groupId !== undefined) {
                localVarQueryParameter['groupId'] = groupId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDefaultCategory: (...args_22) => __awaiter(this, [...args_22], void 0, function* (options = {}) {
            const localVarPath = `/datasets/categories/default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get dataset group object by database id
         * @param {string} groupId Dataset group id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetGroup: (groupId_2, ...args_23) => __awaiter(this, [groupId_2, ...args_23], void 0, function* (groupId, options = {}) {
            // verify required parameter 'groupId' is not null or undefined
            (0, common_1.assertParamExists)('datasetResourceGetGroup', 'groupId', groupId);
            const localVarPath = `/datasets/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (groupId !== undefined) {
                localVarQueryParameter['groupId'] = groupId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all request user company dataset groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetGroups: (...args_24) => __awaiter(this, [...args_24], void 0, function* (options = {}) {
            const localVarPath = `/datasets/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} _class
         * @param {number} datasetId
         * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
         * @param {number} [count]
         * @param {string} [referenceTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetMostRecentData: (_class_1, datasetId_2, adjustContinuous_2, count_2, referenceTime_1, ...args_25) => __awaiter(this, [_class_1, datasetId_2, adjustContinuous_2, count_2, referenceTime_1, ...args_25], void 0, function* (_class, datasetId, adjustContinuous, count, referenceTime, options = {}) {
            // verify required parameter '_class' is not null or undefined
            (0, common_1.assertParamExists)('datasetResourceGetMostRecentData', '_class', _class);
            // verify required parameter 'datasetId' is not null or undefined
            (0, common_1.assertParamExists)('datasetResourceGetMostRecentData', 'datasetId', datasetId);
            const localVarPath = `/datasets/data/recent/{class}/{datasetId}`
                .replace(`{${"class"}}`, encodeURIComponent(String(_class)))
                .replace(`{${"datasetId"}}`, encodeURIComponent(String(datasetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (adjustContinuous !== undefined) {
                localVarQueryParameter['adjustContinuous'] = adjustContinuous;
            }
            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }
            if (referenceTime !== undefined) {
                localVarQueryParameter['referenceTime'] = (referenceTime instanceof Date) ?
                    referenceTime.toISOString() :
                    referenceTime;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [allowEmptyQuery]
         * @param {string} [identifiers]
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetQueryDatasetCount: (allowEmptyQuery_2, identifiers_2, query_2, ...args_26) => __awaiter(this, [allowEmptyQuery_2, identifiers_2, query_2, ...args_26], void 0, function* (allowEmptyQuery, identifiers, query, options = {}) {
            const localVarPath = `/datasets/search/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (allowEmptyQuery !== undefined) {
                localVarQueryParameter['allowEmptyQuery'] = allowEmptyQuery;
            }
            if (identifiers !== undefined) {
                localVarQueryParameter['identifiers'] = identifiers;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get dataset most recent value list using adjusted server time. To calculate adjusted time current server time is truncated to the specified unit and then lead time is added. Most recent values are queried from adjusted time. Values are ordered from newest to oldest.
         * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
         * @param {string} [alignTimeUnit] Current server time truncation ChronoUnit
         * @param {number} [lead] Time lead that is added to the current server time. Use negative values for subtraction
         * @param {string} [leadTimeUnit] Time lead ChronoUnit
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetRecentValues: (adjustContinuous_3, alignTimeUnit_1, lead_1, leadTimeUnit_1, requestBody_2, ...args_27) => __awaiter(this, [adjustContinuous_3, alignTimeUnit_1, lead_1, leadTimeUnit_1, requestBody_2, ...args_27], void 0, function* (adjustContinuous, alignTimeUnit, lead, leadTimeUnit, requestBody, options = {}) {
            const localVarPath = `/datasets/data/recentValues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (adjustContinuous !== undefined) {
                localVarQueryParameter['adjustContinuous'] = adjustContinuous;
            }
            if (alignTimeUnit !== undefined) {
                localVarQueryParameter['alignTimeUnit'] = alignTimeUnit;
            }
            if (lead !== undefined) {
                localVarQueryParameter['lead'] = lead;
            }
            if (leadTimeUnit !== undefined) {
                localVarQueryParameter['leadTimeUnit'] = leadTimeUnit;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * DEPRECATED. Get dataset most recent value list using adjusted server time. To calculate adjusted time current server time is truncated to the specified unit and then lead time is added. Most recent values are queried from adjusted time. Values are ordered from newest to oldest.
         * @param {string} [alignTimeUnit] Current server time truncation ChronoUnit
         * @param {number} [lead] Time lead that is added to the current server time. Use negative values for subtraction
         * @param {string} [leadTimeUnit] Time lead ChronoUnit
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        datasetResourceGetRecentValuesOld: (alignTimeUnit_2, lead_2, leadTimeUnit_2, requestBody_3, ...args_28) => __awaiter(this, [alignTimeUnit_2, lead_2, leadTimeUnit_2, requestBody_3, ...args_28], void 0, function* (alignTimeUnit, lead, leadTimeUnit, requestBody, options = {}) {
            const localVarPath = `/datasets/data/recent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (alignTimeUnit !== undefined) {
                localVarQueryParameter['alignTimeUnit'] = alignTimeUnit;
            }
            if (lead !== undefined) {
                localVarQueryParameter['lead'] = lead;
            }
            if (leadTimeUnit !== undefined) {
                localVarQueryParameter['leadTimeUnit'] = leadTimeUnit;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Hard delete dataset and its data from the database. This operation is irreversible and will remove all data associated with the dataset.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceHardDeleteDataset: (id_4, ...args_29) => __awaiter(this, [id_4, ...args_29], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('datasetResourceHardDeleteDataset', 'id', id);
            const localVarPath = `/datasets/{id}/hard-delete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceSoftDeleteDataset: (id_5, ...args_30) => __awaiter(this, [id_5, ...args_30], void 0, function* (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('datasetResourceSoftDeleteDataset', 'id', id);
            const localVarPath = `/datasets/{id}/soft-delete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {boolean} [fullUpdate]
         * @param {DatasetInfo} [datasetInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceUpdateDatasetInfo: (id_6, fullUpdate_1, datasetInfo_2, ...args_31) => __awaiter(this, [id_6, fullUpdate_1, datasetInfo_2, ...args_31], void 0, function* (id, fullUpdate, datasetInfo, options = {}) {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('datasetResourceUpdateDatasetInfo', 'id', id);
            const localVarPath = `/datasets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (fullUpdate !== undefined) {
                localVarQueryParameter['fullUpdate'] = fullUpdate;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(datasetInfo, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyRef
         * @param {string} id
         * @param {DatasetBindingType} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetsByBinding: (companyRef_1, id_7, type_1, ...args_32) => __awaiter(this, [companyRef_1, id_7, type_1, ...args_32], void 0, function* (companyRef, id, type, options = {}) {
            // verify required parameter 'companyRef' is not null or undefined
            (0, common_1.assertParamExists)('getDatasetsByBinding', 'companyRef', companyRef);
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getDatasetsByBinding', 'id', id);
            // verify required parameter 'type' is not null or undefined
            (0, common_1.assertParamExists)('getDatasetsByBinding', 'type', type);
            const localVarPath = `/datasets/by-binding/{companyRef}/{type}/{id}`
                .replace(`{${"companyRef"}}`, encodeURIComponent(String(companyRef)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {BoundDatasetsRequest} [boundDatasetsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetsByBindingBatch: (boundDatasetsRequest_1, ...args_33) => __awaiter(this, [boundDatasetsRequest_1, ...args_33], void 0, function* (boundDatasetsRequest, options = {}) {
            const localVarPath = `/datasets/by-binding/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(boundDatasetsRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Search datasets by query string
         * @param {boolean} [allowEmptyQuery]
         * @param {string} [companyRef]
         * @param {string} [identifiers]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDatasets: (allowEmptyQuery_3, companyRef_2, identifiers_3, limit_1, page_2, query_3, ...args_34) => __awaiter(this, [allowEmptyQuery_3, companyRef_2, identifiers_3, limit_1, page_2, query_3, ...args_34], void 0, function* (allowEmptyQuery, companyRef, identifiers, limit, page, query, options = {}) {
            const localVarPath = `/datasets/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (allowEmptyQuery !== undefined) {
                localVarQueryParameter['allowEmptyQuery'] = allowEmptyQuery;
            }
            if (companyRef !== undefined) {
                localVarQueryParameter['companyRef'] = companyRef;
            }
            if (identifiers !== undefined) {
                localVarQueryParameter['identifiers'] = identifiers;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.DatasetsApiAxiosParamCreator = DatasetsApiAxiosParamCreator;
/**
 * DatasetsApi - functional programming interface
 * @export
 */
const DatasetsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DatasetsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {DatasetGroupDTO} [datasetGroupDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetGroupsResourceCreateGroup(datasetGroupDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetGroupsResourceCreateGroup(datasetGroupDTO, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetGroupsResourceCreateGroup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetGroupsResourceDeleteGroup(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetGroupsResourceDeleteGroup(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetGroupsResourceDeleteGroup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetGroupsResourceGetAllRootGroups(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetGroupsResourceGetAllRootGroups(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetGroupsResourceGetAllRootGroups']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetGroupsResourceGetGroup(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetGroupsResourceGetGroup(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetGroupsResourceGetGroup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} id
         * @param {DatasetGroupDTO} [datasetGroupDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetGroupsResourceUpdateGroup(id, datasetGroupDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetGroupsResourceUpdateGroup(id, datasetGroupDTO, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetGroupsResourceUpdateGroup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Create categorized(local and remote) dataset
         * @param {DatasetInfo} [datasetInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceCreateCategorizedDataset(datasetInfo, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceCreateCategorizedDataset(datasetInfo, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceCreateCategorizedDataset']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {boolean} [allowEmptyQuery]
         * @param {string} [identifiers]
         * @param {number} [page]
         * @param {string} [query]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetAllDatasetInfosPaginated(allowEmptyQuery, identifiers, page, query, size, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetAllDatasetInfosPaginated(allowEmptyQuery, identifiers, page, query, size, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceGetAllDatasetInfosPaginated']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get all allowed datasets for request user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetAllowedDatasets(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetAllowedDatasets(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceGetAllowedDatasets']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetBaseDataset(identifier, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetBaseDataset(identifier, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceGetBaseDataset']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [categoryIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetCategories(categoryIds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetCategories(categoryIds, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceGetCategories']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [category]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetCompanyCategoryInfo(category, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetCompanyCategoryInfo(category, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceGetCompanyCategoryInfo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [categoryId]
         * @param {string} [tags]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetByTags(categoryId, tags, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetDatasetByTags(categoryId, tags, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceGetDatasetByTags']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetCount(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetDatasetCount(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceGetDatasetCount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get actual dataset data in the provided data period
         * @param {string} dataObj DatasetDataRequestObject which contains DatasetIdentifier and data period start and end localized time moments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetData(dataObj, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetDatasetData(dataObj, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceGetDatasetData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get dataset aggregated data in the provided data period, using the rules defined in query parameters.
         * @param {object} aggregationPeriod ChronoUnit which dictates data aggregation period/frequency
         * @param {number} from Instant object which represents the start of the data period
         * @param {number} to Instant object which represents the end of the data period
         * @param {{ [key: string]: AggregationType; }} [requestBody]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetDataAggregated(aggregationPeriod, from, to, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetDatasetDataAggregated(aggregationPeriod, from, to, requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceGetDatasetDataAggregated']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetInfo(identifier, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetDatasetInfo(identifier, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceGetDatasetInfo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get all user allowed datasets in DatasetDTO format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetList(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetDatasetList(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceGetDatasetList']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get dataset most recent value list using current server time. Values are ordered from newest to oldest.
         * @param {number} datasetId Categorized dataset database ID
         * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
         * @param {number} [count]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetMostRecentValues(datasetId, adjustContinuous, count, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetDatasetMostRecentValues(datasetId, adjustContinuous, count, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceGetDatasetMostRecentValues']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {DatasetRequestFilter} [datasetRequestFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasets(datasetRequestFilter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetDatasets(datasetRequestFilter, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceGetDatasets']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [categoryId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetsByCategory(categoryId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetDatasetsByCategory(categoryId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceGetDatasetsByCategory']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {number} [groupId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetsByGroup(groupId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetDatasetsByGroup(groupId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceGetDatasetsByGroup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDefaultCategory(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetDefaultCategory(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceGetDefaultCategory']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get dataset group object by database id
         * @param {string} groupId Dataset group id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetGroup(groupId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetGroup(groupId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceGetGroup']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get all request user company dataset groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetGroups(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetGroups(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceGetGroups']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} _class
         * @param {number} datasetId
         * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
         * @param {number} [count]
         * @param {string} [referenceTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetMostRecentData(_class, datasetId, adjustContinuous, count, referenceTime, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetMostRecentData(_class, datasetId, adjustContinuous, count, referenceTime, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceGetMostRecentData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {boolean} [allowEmptyQuery]
         * @param {string} [identifiers]
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetQueryDatasetCount(allowEmptyQuery, identifiers, query, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetQueryDatasetCount(allowEmptyQuery, identifiers, query, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceGetQueryDatasetCount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get dataset most recent value list using adjusted server time. To calculate adjusted time current server time is truncated to the specified unit and then lead time is added. Most recent values are queried from adjusted time. Values are ordered from newest to oldest.
         * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
         * @param {string} [alignTimeUnit] Current server time truncation ChronoUnit
         * @param {number} [lead] Time lead that is added to the current server time. Use negative values for subtraction
         * @param {string} [leadTimeUnit] Time lead ChronoUnit
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetRecentValues(adjustContinuous, alignTimeUnit, lead, leadTimeUnit, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetRecentValues(adjustContinuous, alignTimeUnit, lead, leadTimeUnit, requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceGetRecentValues']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * DEPRECATED. Get dataset most recent value list using adjusted server time. To calculate adjusted time current server time is truncated to the specified unit and then lead time is added. Most recent values are queried from adjusted time. Values are ordered from newest to oldest.
         * @param {string} [alignTimeUnit] Current server time truncation ChronoUnit
         * @param {number} [lead] Time lead that is added to the current server time. Use negative values for subtraction
         * @param {string} [leadTimeUnit] Time lead ChronoUnit
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        datasetResourceGetRecentValuesOld(alignTimeUnit, lead, leadTimeUnit, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetRecentValuesOld(alignTimeUnit, lead, leadTimeUnit, requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceGetRecentValuesOld']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Hard delete dataset and its data from the database. This operation is irreversible and will remove all data associated with the dataset.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceHardDeleteDataset(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceHardDeleteDataset(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceHardDeleteDataset']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceSoftDeleteDataset(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceSoftDeleteDataset(id, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceSoftDeleteDataset']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} id
         * @param {boolean} [fullUpdate]
         * @param {DatasetInfo} [datasetInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceUpdateDatasetInfo(id, fullUpdate, datasetInfo, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceUpdateDatasetInfo(id, fullUpdate, datasetInfo, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.datasetResourceUpdateDatasetInfo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} companyRef
         * @param {string} id
         * @param {DatasetBindingType} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetsByBinding(companyRef, id, type, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDatasetsByBinding(companyRef, id, type, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.getDatasetsByBinding']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {BoundDatasetsRequest} [boundDatasetsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetsByBindingBatch(boundDatasetsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDatasetsByBindingBatch(boundDatasetsRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.getDatasetsByBindingBatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Search datasets by query string
         * @param {boolean} [allowEmptyQuery]
         * @param {string} [companyRef]
         * @param {string} [identifiers]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDatasets(allowEmptyQuery, companyRef, identifiers, limit, page, query, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchDatasets(allowEmptyQuery, companyRef, identifiers, limit, page, query, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsApi.searchDatasets']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.DatasetsApiFp = DatasetsApiFp;
/**
 * DatasetsApi - factory interface
 * @export
 */
const DatasetsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DatasetsApiFp)(configuration);
    return {
        /**
         *
         * @param {DatasetsApiDatasetGroupsResourceCreateGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetGroupsResourceCreateGroup(requestParameters = {}, options) {
            return localVarFp.datasetGroupsResourceCreateGroup(requestParameters.datasetGroupDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetsApiDatasetGroupsResourceDeleteGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetGroupsResourceDeleteGroup(requestParameters, options) {
            return localVarFp.datasetGroupsResourceDeleteGroup(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetGroupsResourceGetAllRootGroups(options) {
            return localVarFp.datasetGroupsResourceGetAllRootGroups(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetsApiDatasetGroupsResourceGetGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetGroupsResourceGetGroup(requestParameters, options) {
            return localVarFp.datasetGroupsResourceGetGroup(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetsApiDatasetGroupsResourceUpdateGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetGroupsResourceUpdateGroup(requestParameters, options) {
            return localVarFp.datasetGroupsResourceUpdateGroup(requestParameters.id, requestParameters.datasetGroupDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Create categorized(local and remote) dataset
         * @param {DatasetsApiDatasetResourceCreateCategorizedDatasetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceCreateCategorizedDataset(requestParameters = {}, options) {
            return localVarFp.datasetResourceCreateCategorizedDataset(requestParameters.datasetInfo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetsApiDatasetResourceGetAllDatasetInfosPaginatedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetAllDatasetInfosPaginated(requestParameters = {}, options) {
            return localVarFp.datasetResourceGetAllDatasetInfosPaginated(requestParameters.allowEmptyQuery, requestParameters.identifiers, requestParameters.page, requestParameters.query, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all allowed datasets for request user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetAllowedDatasets(options) {
            return localVarFp.datasetResourceGetAllowedDatasets(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetsApiDatasetResourceGetBaseDatasetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetBaseDataset(requestParameters, options) {
            return localVarFp.datasetResourceGetBaseDataset(requestParameters.identifier, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetsApiDatasetResourceGetCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetCategories(requestParameters = {}, options) {
            return localVarFp.datasetResourceGetCategories(requestParameters.categoryIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetsApiDatasetResourceGetCompanyCategoryInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetCompanyCategoryInfo(requestParameters = {}, options) {
            return localVarFp.datasetResourceGetCompanyCategoryInfo(requestParameters.category, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetsApiDatasetResourceGetDatasetByTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetByTags(requestParameters = {}, options) {
            return localVarFp.datasetResourceGetDatasetByTags(requestParameters.categoryId, requestParameters.tags, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetCount(options) {
            return localVarFp.datasetResourceGetDatasetCount(options).then((request) => request(axios, basePath));
        },
        /**
         * Get actual dataset data in the provided data period
         * @param {DatasetsApiDatasetResourceGetDatasetDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetData(requestParameters, options) {
            return localVarFp.datasetResourceGetDatasetData(requestParameters.dataObj, options).then((request) => request(axios, basePath));
        },
        /**
         * Get dataset aggregated data in the provided data period, using the rules defined in query parameters.
         * @param {DatasetsApiDatasetResourceGetDatasetDataAggregatedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetDataAggregated(requestParameters, options) {
            return localVarFp.datasetResourceGetDatasetDataAggregated(requestParameters.aggregationPeriod, requestParameters.from, requestParameters.to, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetsApiDatasetResourceGetDatasetInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetInfo(requestParameters, options) {
            return localVarFp.datasetResourceGetDatasetInfo(requestParameters.identifier, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all user allowed datasets in DatasetDTO format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetList(options) {
            return localVarFp.datasetResourceGetDatasetList(options).then((request) => request(axios, basePath));
        },
        /**
         * Get dataset most recent value list using current server time. Values are ordered from newest to oldest.
         * @param {DatasetsApiDatasetResourceGetDatasetMostRecentValuesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetMostRecentValues(requestParameters, options) {
            return localVarFp.datasetResourceGetDatasetMostRecentValues(requestParameters.datasetId, requestParameters.adjustContinuous, requestParameters.count, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetsApiDatasetResourceGetDatasetsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasets(requestParameters = {}, options) {
            return localVarFp.datasetResourceGetDatasets(requestParameters.datasetRequestFilter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetsApiDatasetResourceGetDatasetsByCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetsByCategory(requestParameters = {}, options) {
            return localVarFp.datasetResourceGetDatasetsByCategory(requestParameters.categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetsApiDatasetResourceGetDatasetsByGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDatasetsByGroup(requestParameters = {}, options) {
            return localVarFp.datasetResourceGetDatasetsByGroup(requestParameters.groupId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetDefaultCategory(options) {
            return localVarFp.datasetResourceGetDefaultCategory(options).then((request) => request(axios, basePath));
        },
        /**
         * Get dataset group object by database id
         * @param {DatasetsApiDatasetResourceGetGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetGroup(requestParameters, options) {
            return localVarFp.datasetResourceGetGroup(requestParameters.groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all request user company dataset groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetGroups(options) {
            return localVarFp.datasetResourceGetGroups(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetsApiDatasetResourceGetMostRecentDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetMostRecentData(requestParameters, options) {
            return localVarFp.datasetResourceGetMostRecentData(requestParameters._class, requestParameters.datasetId, requestParameters.adjustContinuous, requestParameters.count, requestParameters.referenceTime, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetsApiDatasetResourceGetQueryDatasetCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetQueryDatasetCount(requestParameters = {}, options) {
            return localVarFp.datasetResourceGetQueryDatasetCount(requestParameters.allowEmptyQuery, requestParameters.identifiers, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * Get dataset most recent value list using adjusted server time. To calculate adjusted time current server time is truncated to the specified unit and then lead time is added. Most recent values are queried from adjusted time. Values are ordered from newest to oldest.
         * @param {DatasetsApiDatasetResourceGetRecentValuesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetRecentValues(requestParameters = {}, options) {
            return localVarFp.datasetResourceGetRecentValues(requestParameters.adjustContinuous, requestParameters.alignTimeUnit, requestParameters.lead, requestParameters.leadTimeUnit, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * DEPRECATED. Get dataset most recent value list using adjusted server time. To calculate adjusted time current server time is truncated to the specified unit and then lead time is added. Most recent values are queried from adjusted time. Values are ordered from newest to oldest.
         * @param {DatasetsApiDatasetResourceGetRecentValuesOldRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        datasetResourceGetRecentValuesOld(requestParameters = {}, options) {
            return localVarFp.datasetResourceGetRecentValuesOld(requestParameters.alignTimeUnit, requestParameters.lead, requestParameters.leadTimeUnit, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Hard delete dataset and its data from the database. This operation is irreversible and will remove all data associated with the dataset.
         * @param {DatasetsApiDatasetResourceHardDeleteDatasetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceHardDeleteDataset(requestParameters, options) {
            return localVarFp.datasetResourceHardDeleteDataset(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetsApiDatasetResourceSoftDeleteDatasetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceSoftDeleteDataset(requestParameters, options) {
            return localVarFp.datasetResourceSoftDeleteDataset(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetsApiDatasetResourceUpdateDatasetInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceUpdateDatasetInfo(requestParameters, options) {
            return localVarFp.datasetResourceUpdateDatasetInfo(requestParameters.id, requestParameters.fullUpdate, requestParameters.datasetInfo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetsApiGetDatasetsByBindingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetsByBinding(requestParameters, options) {
            return localVarFp.getDatasetsByBinding(requestParameters.companyRef, requestParameters.id, requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetsApiGetDatasetsByBindingBatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetsByBindingBatch(requestParameters = {}, options) {
            return localVarFp.getDatasetsByBindingBatch(requestParameters.boundDatasetsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Search datasets by query string
         * @param {DatasetsApiSearchDatasetsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDatasets(requestParameters = {}, options) {
            return localVarFp.searchDatasets(requestParameters.allowEmptyQuery, requestParameters.companyRef, requestParameters.identifiers, requestParameters.limit, requestParameters.page, requestParameters.query, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DatasetsApiFactory = DatasetsApiFactory;
/**
 * DatasetsApi - object-oriented interface
 * @export
 * @class DatasetsApi
 * @extends {BaseAPI}
 */
class DatasetsApi extends base_1.BaseAPI {
    /**
     *
     * @param {DatasetsApiDatasetGroupsResourceCreateGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetGroupsResourceCreateGroup(requestParameters = {}, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetGroupsResourceCreateGroup(requestParameters.datasetGroupDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetsApiDatasetGroupsResourceDeleteGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetGroupsResourceDeleteGroup(requestParameters, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetGroupsResourceDeleteGroup(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetGroupsResourceGetAllRootGroups(options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetGroupsResourceGetAllRootGroups(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetsApiDatasetGroupsResourceGetGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetGroupsResourceGetGroup(requestParameters, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetGroupsResourceGetGroup(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetsApiDatasetGroupsResourceUpdateGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetGroupsResourceUpdateGroup(requestParameters, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetGroupsResourceUpdateGroup(requestParameters.id, requestParameters.datasetGroupDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create categorized(local and remote) dataset
     * @param {DatasetsApiDatasetResourceCreateCategorizedDatasetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceCreateCategorizedDataset(requestParameters = {}, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceCreateCategorizedDataset(requestParameters.datasetInfo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetsApiDatasetResourceGetAllDatasetInfosPaginatedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceGetAllDatasetInfosPaginated(requestParameters = {}, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceGetAllDatasetInfosPaginated(requestParameters.allowEmptyQuery, requestParameters.identifiers, requestParameters.page, requestParameters.query, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all allowed datasets for request user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceGetAllowedDatasets(options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceGetAllowedDatasets(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetsApiDatasetResourceGetBaseDatasetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceGetBaseDataset(requestParameters, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceGetBaseDataset(requestParameters.identifier, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetsApiDatasetResourceGetCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceGetCategories(requestParameters = {}, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceGetCategories(requestParameters.categoryIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetsApiDatasetResourceGetCompanyCategoryInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceGetCompanyCategoryInfo(requestParameters = {}, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceGetCompanyCategoryInfo(requestParameters.category, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetsApiDatasetResourceGetDatasetByTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceGetDatasetByTags(requestParameters = {}, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceGetDatasetByTags(requestParameters.categoryId, requestParameters.tags, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceGetDatasetCount(options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceGetDatasetCount(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get actual dataset data in the provided data period
     * @param {DatasetsApiDatasetResourceGetDatasetDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceGetDatasetData(requestParameters, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceGetDatasetData(requestParameters.dataObj, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get dataset aggregated data in the provided data period, using the rules defined in query parameters.
     * @param {DatasetsApiDatasetResourceGetDatasetDataAggregatedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceGetDatasetDataAggregated(requestParameters, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceGetDatasetDataAggregated(requestParameters.aggregationPeriod, requestParameters.from, requestParameters.to, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetsApiDatasetResourceGetDatasetInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceGetDatasetInfo(requestParameters, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceGetDatasetInfo(requestParameters.identifier, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all user allowed datasets in DatasetDTO format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceGetDatasetList(options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceGetDatasetList(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get dataset most recent value list using current server time. Values are ordered from newest to oldest.
     * @param {DatasetsApiDatasetResourceGetDatasetMostRecentValuesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceGetDatasetMostRecentValues(requestParameters, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceGetDatasetMostRecentValues(requestParameters.datasetId, requestParameters.adjustContinuous, requestParameters.count, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetsApiDatasetResourceGetDatasetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceGetDatasets(requestParameters = {}, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceGetDatasets(requestParameters.datasetRequestFilter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetsApiDatasetResourceGetDatasetsByCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceGetDatasetsByCategory(requestParameters = {}, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceGetDatasetsByCategory(requestParameters.categoryId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetsApiDatasetResourceGetDatasetsByGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceGetDatasetsByGroup(requestParameters = {}, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceGetDatasetsByGroup(requestParameters.groupId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceGetDefaultCategory(options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceGetDefaultCategory(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get dataset group object by database id
     * @param {DatasetsApiDatasetResourceGetGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceGetGroup(requestParameters, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceGetGroup(requestParameters.groupId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all request user company dataset groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceGetGroups(options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceGetGroups(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetsApiDatasetResourceGetMostRecentDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceGetMostRecentData(requestParameters, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceGetMostRecentData(requestParameters._class, requestParameters.datasetId, requestParameters.adjustContinuous, requestParameters.count, requestParameters.referenceTime, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetsApiDatasetResourceGetQueryDatasetCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceGetQueryDatasetCount(requestParameters = {}, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceGetQueryDatasetCount(requestParameters.allowEmptyQuery, requestParameters.identifiers, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get dataset most recent value list using adjusted server time. To calculate adjusted time current server time is truncated to the specified unit and then lead time is added. Most recent values are queried from adjusted time. Values are ordered from newest to oldest.
     * @param {DatasetsApiDatasetResourceGetRecentValuesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceGetRecentValues(requestParameters = {}, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceGetRecentValues(requestParameters.adjustContinuous, requestParameters.alignTimeUnit, requestParameters.lead, requestParameters.leadTimeUnit, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * DEPRECATED. Get dataset most recent value list using adjusted server time. To calculate adjusted time current server time is truncated to the specified unit and then lead time is added. Most recent values are queried from adjusted time. Values are ordered from newest to oldest.
     * @param {DatasetsApiDatasetResourceGetRecentValuesOldRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceGetRecentValuesOld(requestParameters = {}, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceGetRecentValuesOld(requestParameters.alignTimeUnit, requestParameters.lead, requestParameters.leadTimeUnit, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Hard delete dataset and its data from the database. This operation is irreversible and will remove all data associated with the dataset.
     * @param {DatasetsApiDatasetResourceHardDeleteDatasetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceHardDeleteDataset(requestParameters, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceHardDeleteDataset(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetsApiDatasetResourceSoftDeleteDatasetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceSoftDeleteDataset(requestParameters, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceSoftDeleteDataset(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetsApiDatasetResourceUpdateDatasetInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetResourceUpdateDatasetInfo(requestParameters, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetResourceUpdateDatasetInfo(requestParameters.id, requestParameters.fullUpdate, requestParameters.datasetInfo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetsApiGetDatasetsByBindingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    getDatasetsByBinding(requestParameters, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).getDatasetsByBinding(requestParameters.companyRef, requestParameters.id, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetsApiGetDatasetsByBindingBatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    getDatasetsByBindingBatch(requestParameters = {}, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).getDatasetsByBindingBatch(requestParameters.boundDatasetsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Search datasets by query string
     * @param {DatasetsApiSearchDatasetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    searchDatasets(requestParameters = {}, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).searchDatasets(requestParameters.allowEmptyQuery, requestParameters.companyRef, requestParameters.identifiers, requestParameters.limit, requestParameters.page, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DatasetsApi = DatasetsApi;
//# sourceMappingURL=datasets-api.js.map